import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../Provider/AuthProvider";

const AdminRoute = ({ children }) => {
    const { user, loading } = useContext(AuthContext);
    const location = useLocation();

    if (loading) {
        return <div>Loading...</div>;
    }

    // If logged in & admin → show page
    if (user?.email && user?.role === "admin" && user?.admin_approval_status === "approved") {
        return children;
    }
    
    // If not admin or not logged in → pretend the page doesn't exist
    return <Navigate to="*" state={{ from: location }} replace />;
};

export default AdminRoute;
